module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"dialog\" title=\"Migrate\" style=\"display: none;\">\r\n    <form class=\"migrate-form form-horizontal\">\r\n        <div class=\"container-fluid\">\r\n            <div class=\"row\">\r\n                <span class=\"header\">Export</span>\r\n                <hr />\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"radio\">\r\n                    <label>\r\n                        <input type=\"radio\" name=\"action\" value=\"fix\" checked>\r\n                        Data History as XML\r\n                    </label>\r\n                </div>\r\n                <div class=\"radio\">\r\n                    <label>\r\n                        <input type=\"radio\" name=\"action\" value=\"fic\">\r\n                        Data History as CSV\r\n                    </label>\r\n                </div>\r\n            </div>            \r\n        </div>\r\n    </form>\r\n</div>")
  }
  return __output;

}